/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Card_TitleInputs */

const en_login_card_title = /** @type {(inputs: Login_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const de_login_card_title = /** @type {(inputs: Login_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Login_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_card_title = /** @type {((inputs?: Login_Card_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Card_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_card_title(inputs)
	return en_login_card_title(inputs)
});